import React, {Component} from "react"

import {Tooltip} from "@irati/ui/src/Tooltip"
import Flex from "@irati/ui/src/Flex"
import {H2, Label} from "@irati/ui/src/Typography"
import {FormattedMessage, injectIntl, InjectIntl} from "@irati/utils/lang"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import mainTheme from "@irati/ui/src/global/theme"

import LinkToFAQ from "./LinkToFAQ"
import {Wrapper} from "./styled"

interface Props extends InjectIntl {
  summaries: Summary[]
  hideVisits: boolean
}

interface Summary {
  title: string
  description: string
  value: number
  linksToFAQ?: boolean
}

class SummaryList extends Component<Props> {
  buildTooltip = (summary: Summary) => {
    const {formatMessage} = this.props
    if (summary?.linksToFAQ) {
      const desc = summary.description
      return (
        <>
          <FormattedMessage id={desc} />
          <LinkToFAQ />
        </>
      )
    }
    return formatMessage({id: summary.description})
  }

  render() {
    const {summaries = [], hideVisits, formatMessage} = this.props
    return (
      <Wrapper id="adminSection_summaryListSection">
        <Flex justifyContent="space-around">
          {summaries
            .filter((_summary: Summary, index) => index !== 0 || !hideVisits)
            .map((summary: Summary) => (
              <div>
                <H2 textAlign="center">{summary.value}</H2>
                <Label marginRight={0.5}>{formatMessage({id: summary.title})}</Label>
                <Tooltip tooltipChildren={this.buildTooltip(summary)} placement="right" delayHide={1000}>
                  <Icon icon={IconTypes.info} color={mainTheme.colors.primary1} />
                </Tooltip>
              </div>
            ))}
        </Flex>
      </Wrapper>
    )
  }
}

export default injectIntl(SummaryList)
